export const locale = {
    lang: 'ar',
    data: {
        ADD: 'أضف فقرة',
        TITLE: 'عنوان',
        SAVE: 'حِفْظْ',
        CANCEL: 'إلغاء',
    }
};
